// Here create global constants

export const ERROR = {
  REQUIRED: {
    EMAIL: 'Please enter Email',
    PASSWORD: 'Please enter Password',
    AGENCY_NAME: 'Please enter Agency Name',
    NAME: 'Please enter Name',
    MANAGER: 'Please select Manager',
  },
  NOT_VALID: {
    EMAIL: 'Not a valid Email',
    PASSWORD: 'Not a valid Password',
    AGENCY_NAME: 'Not a valid Agency Name',
    NAME: 'Not a valid Name',
  },
};

export const ROLE = {
  HR: 'HR',
  CEO: 'CEO',
  MEMBER: 'Member',
  MANAGER: 'Manager',
};

export const MEMBER_CATEGORY = {
  INADEQUATE: 'Inadequate',
  ADEQUATE: 'Adequate',
  SATISFACTORY: 'Satisfactory',
  GOOD: 'Good',
  EXCELLENT: 'Excellent',
};

export const MEMBER_STATUS = {
  INADEQUATE: 1,
  ADEQUATE: 2,
  SATISFACTORY: 3,
  GOOD: 4,
  EXCELLENT: 5,
};

export const MEMBER_STATUSES = [
  {
    label: 'Inadequate',
    value: 1,
  },
  {
    label: 'Adequate',
    value: 2,
  },
  {
    label: 'Satisfactory',
    value: 3,
  },
  {
    label: 'Good',
    value: 4,
  },
  {
    label: 'Excellent',
    value: 5,
  },
];
